import { render, staticRenderFns } from "./BarcodeSetup.vue?vue&type=template&id=2c41d17b&scoped=true&"
import script from "./BarcodeSetup.vue?vue&type=script&lang=js&"
export * from "./BarcodeSetup.vue?vue&type=script&lang=js&"
import style0 from "./BarcodeSetup.vue?vue&type=style&index=0&id=2c41d17b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41d17b",
  null
  
)

export default component.exports